<template>
    <div>
        <v-container>
            <v-row no-gutters>
                <v-col cols="12">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link class="link-a" to="/Permission/Manage"
                            >Permission </router-link
                        >/
                        <router-link
                            class="link-a"
                            :to="'/Permission/Manage/' + teamId"
                            >Role </router-link
                        >/ Main Menu
                    </h1>
                </v-col>
            </v-row>
            <v-card class="mt-5">
                <v-row>
                    <v-col cols="12">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th class="text-center">Main Menu</th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="(row, index) in datas"
                                        :key="row.menu_id"
                                    >
                                        <td class="text-center">
                                            {{ index + 1 }}.
                                        </td>
                                        <td>{{ row.menu_name }}</td>
                                        <td class="text-center">
                                            <v-icon
                                                :color="
                                                    row.menu_status == 1
                                                        ? 'success'
                                                        : 'red'
                                                "
                                                >{{
                                                    row.menu_status == 1
                                                        ? "mdi-checkbox-marked-circle"
                                                        : "mdi-close-circle"
                                                }}</v-icon
                                            >
                                        </td>
                                        <td class="text-center">
                                            <v-btn
                                                color="info"
                                                fab
                                                x-small
                                                :to="
                                                    '/Permission/Manage/' +
                                                        teamId +
                                                        '/' +
                                                        roleId +
                                                        '/' +
                                                        row.menu_id
                                                "
                                                ><v-icon x-small
                                                    >mdi-plus</v-icon
                                                >
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/menu/`

export default {
    mounted() {
        this.get_data()
    },
    methods: {
        async get_data() {
            this.teamId = this.$route.params.team_id
            this.roleId = this.$route.params.role_id

            let { data } = await axios.get(url)
            this.datas = data
        }
    },
    data() {
        return {
            datas: [],
            teamId: 0,
            roleId: 0
        }
    }
}
</script>
